import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_AUTH_RESOURCE_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE,
    specificAuthKeyName: 'user-auth-resource'
}

const service = {
    authResource () {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get(`/user-auth-resource/${process.env.VUE_APP_SERVICE}`)
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
